import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/toPromise';

import { config } from "./../../../../configuration";
import { ServerResponse } from '../utils/server-response';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DataService {
  public url;
  // Observable string source
  protected request = new Subject<any>();

  // Observable string stream
  public request$ = this.request.asObservable();

  // Service message commands
  public insertData(data: string) {
    this.request.next(data)
  }

  constructor(private http: HttpClient) {
    this.request$.subscribe(
      data => {
        this.url = `${config.apiUrl}${data}`;
      });
    }

    getList() {
      return this.http.get(this.url)
      .map((response: Response) =>{return response})
      .catch(this.handleError);
    }

    getListByUrl(url) {
      return this.http.get(`${config.apiUrl}${url}`)
      .map((response: Response) =>{return response})
      .catch(this.handleError);
    }

    get(id) {
      return this.http.get(`${this.url}/${id}`)
      .map((response: Response) => response)
      .catch(this.handleError);
    }

    delete(id) {
      return this.http.delete(`${this.url}/${id}`)
      .map((response: Response) => response)
      .catch(this.handleError);
    }

    add(body) {
      console.log(body)
      let bodyString = JSON.stringify(body);
      return this.http.post(this.url, bodyString)
      .map((response: Response) => response)
      .catch(this.handleError);
    }

    update(body) {
      let id = body._id;
      delete body.__v;
      let bodyString = JSON.stringify(body);

      return this.http.put(`${this.url}/${id}`, bodyString)
      .map((response: Response) => response)
      .catch(this.handleError);
    }

    private handleError(error) {
      return Observable.throw(error);
    }
  }



// WEBPACK FOOTER //
// ./src/app/shared/api.service.ts